import React from 'react';

function PrefooterCard() {
  return (
    <div className="tm-pf-card">
      <div className="tm-pf-row tm-tip">
        <span className="tm-pf-icon" aria-hidden>🚚</span>
        <span className="tm-pf-text">Métodos de envío</span>
        <div className="tm-tip-bubble">Envios a CABA y GBA a bajo costo!</div>
      </div>
      <div className="tm-pf-row tm-tip">
        <span className="tm-pf-icon" aria-hidden>💳</span>
        <span className="tm-pf-text">Medios de pago</span>
        <div className="tm-tip-bubble">Efectivo<br/>Transferencia<br/>Tarjeta de crédito<br/>Tarjeta de débito</div>
      </div>
      <div className="tm-pf-row tm-tip">
        <span className="tm-pf-icon" aria-hidden>📍</span>
        <span className="tm-pf-text">Punto de retiro</span>
        <div className="tm-tip-bubble">Merlo</div>
      </div>
    </div>
  );
}

export default PrefooterCard;


